import { render } from "./NuovaIscrizione.vue?vue&type=template&id=3841e6e2&scoped=true"
import script from "./NuovaIscrizione.vue?vue&type=script&lang=js"
export * from "./NuovaIscrizione.vue?vue&type=script&lang=js"

import "./NuovaIscrizione.vue?vue&type=style&index=0&id=3841e6e2&lang=css"
import "./NuovaIscrizione.vue?vue&type=style&index=1&id=3841e6e2&scoped=true&lang=css"

import exportComponent from "/var/www/html/levante_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3841e6e2"]])

export default __exports__